// eslint-disable-next-line import/no-extraneous-dependencies
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
// eslint-disable-next-line import/no-extraneous-dependencies
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import React, { KeyboardEvent } from "react";
import LogService from "../../services/LogService";
import { Filter } from "./datafilter-types";
import DateInput from "./DateInput";
import { checkIfStringEmpty } from "./datafilter-helpers";

interface DateFilterProps {
  filter: Filter;
  onChangeDateTime: (name: string, value: Date | null) => void;
}
const utcIsoToLocalDate = (isoString: string): Date => {
  const d = new Date(isoString);
  return new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
};

const DateFilter: (props: DateFilterProps) => JSX.Element = ({
  filter,
  onChangeDateTime,
}) => {
  const { name, placeholder, value } = filter;
  const raw = checkIfStringEmpty(value);
  const datePickerValue = raw ? utcIsoToLocalDate(raw) : null;

  const onKeyDown = (e: KeyboardEvent<HTMLImageElement>) => {
    e.preventDefault();
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} key={name}>
      <DatePicker
        inputFormat="yyyy-MM-dd"
        mask="____-__-__"
        onAccept={(value: any) => onChangeDateTime(name, value)}
        onChange={() => LogService.log("Date value changed")}
        renderInput={(props: any) => (
          <DateInput
            onKeyDown={onKeyDown}
            {...props}
            placeholder={placeholder}
            name={name}
          />
        )}
        value={datePickerValue}
      />
    </LocalizationProvider>
  );
};

export default DateFilter;
